module.exports = __webpack_public_path__ + "img/inception_ai_assessments.31c5b601.png";